import Analysis from "../components/Analysis"

/**
 * Component for ecographic image analysis
 * This is a wrapper around the unified Analysis component
 *
 * @returns {JSX.Element} AnalisisEcograph component
 */
const AnalisisEcograph = () => {
  return <Analysis analysisType="ecograph" />
}

export default AnalisisEcograph
